<template>
  <v-footer color="color1 anchor--text" padless>
    <v-row justify="center" no-gutters>
      <v-col class="color2 py-4" cols="12">
        <v-row justify="center" align="center">
          <v-col cols="auto">
            Copyright &copy; 2020 -
            <strong>Dr. Rashmee Rajkarnikar</strong>
          </v-col>
          <v-col cols="auto"><strong><span>|</span></strong></v-col>
          
          <v-col cols="auto">Powered <v-icon color="black">mdi-power-plug</v-icon> by 
            <v-hover v-slot:default="{ hover }"><span :class="hover ? 'onHoverLink' : 'noHoverLink'" @click.prevent="okkharClicked('footer')">Okkhar</span></v-hover>
          </v-col>
          
          <v-col cols="auto"><strong><span>|</span></strong></v-col>
          
          <v-col cols="auto"><app-version-dialog></app-version-dialog></v-col>
          
          <v-col cols="auto"><strong><span>|</span></strong></v-col>
          
          <v-col cols="auto">
            <v-icon left>mdi-email</v-icon>
            <v-hover v-slot:default="{ hover }">
              <span :class="hover ? 'onHoverLink' : 'noHoverLink'" @click="gotoContact()">{{ $t("contact") }}</span>
            </v-hover>
          </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col cols="auto">
            <v-hover v-slot:default="{ hover }">
              <span :class="hover ? 'onHoverLink' : 'noHoverLink'" @click="gotoRoute('privacyPolicy')">Privacy Policy</span>
            </v-hover>
          </v-col>
          
          <v-col cols="auto"><strong><span>|</span></strong></v-col>
          
          <v-col cols="auto">
            <v-hover v-slot:default="{ hover }">
              <span :class="hover ? 'onHoverLink' : 'noHoverLink'" @click="gotoRoute('termsAndConditions')">Terms & Conditions</span>
            </v-hover>
          </v-col>
          
          <v-col cols="auto"><strong><span>|</span></strong></v-col>
          
          <v-col cols="auto">
            <v-hover v-slot:default="{ hover }">
              <span :class="hover ? 'onHoverLink' : 'noHoverLink'" @click="gotoRoute('disclaimer')">Disclaimer</span>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import VersionDialog from "@/components/common/VersionDialog";
export default {
  name: "Footer",
  components: {
    appVersionDialog: VersionDialog
  },
  data() {
    return {};
  },
  computed: {
    getTabs() {
      return this.$store.getters.commonTabs;
    }
  },
  methods: {
    gotoContact() {
      this.logEvent("button_click", {
        name: "contact",
        from: "footer"
      })
      if (this.$route.name !== "home") {
        this.$router.push({name: "home" });
      }
      this.contactBannerVisible()
        .then(() => {
          this.$vuetify.goTo("#contactMe", 50, 200);
        });      
    },
    contactBannerVisible() {
      const prom = resolve => {
        if (!document.getElementById("contactMe")) {
          setTimeout(() => prom(resolve), 100);
        } else {
          resolve();
        }
      };
      return new Promise(prom);
    }
  }
};
</script>

<style>
.noHoverLink {
  color: black !important;
  text-decoration: underline !important;
  cursor: pointer;
}
.onHoverLink {
  color: blue !important;
  cursor: pointer;
}
</style>
